import { jsx as _jsx } from "react/jsx-runtime";
import { CheckboxGroup as ChakraCheckboxGroup } from '@chakra-ui/react';
/**
 * Used for multiple checkboxes which are bound in one group,
 * and it indicates whether one or more options are selected.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/checkbox-group
 */
export function CheckboxGroup({ children, ...props }) {
    return _jsx(ChakraCheckboxGroup, { ...props, children: children });
}
//# sourceMappingURL=checkbox-group.js.map